import { arrayOf, bool, func, object, string } from 'prop-types';
import React from 'react';
import { Col, Row, Table } from 'reactstrap';

import CreativesPreview from '../../campaign-line-creatives/CreativesPreview.container';
import { isCountdown } from '../../products/utils';
import { campaignLineShape } from '../../prop-types';
import ClmContentPreview from '../ClmContentPreview/ClmContentPreview';
import { campaignLineStatuses, lineLanguages } from '../constants';
import { findLanguageLineNumber, hasNoFields } from '../utils';
import LanguageHeaderLine from './LanguageHeaderLine';
import LanguageIndependentCampaignLine from './LanguageIndependentCampaignLine';
import LanguageLine from './LanguageLine';

function CampaignLine({
  line,
  onChange,
  onRemove,
  label,
  id,
  areCreativesVisible,
  disableTextAssets,
  contentfulCreatives,
}) {
  const languages = lineLanguages(line);
  const numberOfLanguages = languages.length;
  const countdown = isCountdown({ code: line.product.code });
  const { countryCode, gender, categories, productTag, clmContentPreview } =
    line;

  return (
    <div id={id} className="c-campaign-line c-campaign-line--level-3">
      <LanguageIndependentCampaignLine
        line={line}
        label={label}
        onChange={onChange}
      />
      {areCreativesVisible && (
        <Row>
          <Col sm={3} />
          <Col sm={9}>
            <CreativesPreview
              campaignLineId={line.id}
              readOnly={[
                campaignLineStatuses.PUSHED,
                campaignLineStatuses.LOCKED,
              ].includes(line.status)}
            />
          </Col>
        </Row>
      )}
      {clmContentPreview && (
        <Row>
          <Col sm={3} />
          <Col sm={9}>
            <ClmContentPreview
              clmContentPreview={clmContentPreview}
              countryCode={countryCode}
              gender={gender}
              productTag={productTag}
              categories={categories}
              contentfulCreatives={contentfulCreatives}
            />
          </Col>
        </Row>
      )}
      {numberOfLanguages > 0 && !hasNoFields(line) && !countdown && (
        <Table borderless className="mb-0 mt-2 table-sm">
          <thead>
            <LanguageHeaderLine line={line} />
          </thead>
          <tbody>
            {languages.map(lang => (
              <LanguageLine
                removable={numberOfLanguages > 1}
                key={lang}
                languageIndex={findLanguageLineNumber(line, lang)}
                line={line}
                onChange={onChange}
                onRemove={onRemove}
                readOnly={disableTextAssets}
              />
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
}

CampaignLine.propTypes = {
  label: string.isRequired,
  line: campaignLineShape.isRequired,
  onChange: func.isRequired,
  onRemove: func.isRequired,
  id: string.isRequired,
  areCreativesVisible: bool.isRequired,
  disableTextAssets: bool,
  contentfulCreatives: arrayOf(object.isRequired).isRequired,
};

CampaignLine.defaultProps = {
  disableTextAssets: false,
};

export default CampaignLine;
